import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Grid, Hidden, IconButton } from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik, yupToFormErrors } from 'formik';
import { useDispatch } from 'react-redux';

import { MFTextField, MFSubmitButton } from '../../lib/formik';
import { CommonLayout } from '../commonComponents';
import { DPNameType } from '../../redux-store/types/api-types';
import { addDPName, getDPNameList, updateDPName } from '../../redux-store/actions/userManagement';
// import { addBrokerValidation } from './validation';

const initialBrokerValues: DPNameType = {
  id: null,
  brokerName: '',
};

export default function AddBroker({
  location,
}: {
  location: { state?: { brokerId?: number } };
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();

  const { brokerId } = location.state || {};

  const [brokerInitialValues, setBrokerInitialValues] = useState<DPNameType>(initialBrokerValues);

  useEffect(() => {
    if (!brokerId) return;

    const fetchBroker = async () => {
      const brokers = (await dispatch(getDPNameList())) as unknown as DPNameType[];

      const broker = brokers.find((item) => Number(item.id) === Number(brokerId));
      if (broker) {
        setBrokerInitialValues({
          id: broker.id,
          brokerName: broker.brokerName || '',
        });
      }
    };

    fetchBroker();
  }, [brokerId]);

  const handleSubmit = async (values: DPNameType) => {
    try {
      if (brokerId) {
        const originalName = (brokerInitialValues.brokerName ?? '').trim();
        const currentName = (values.brokerName ?? '').trim();
        if (originalName === currentName) {
          history.push('/broker-name');
          return;
        }

        const updatedBroker = (await dispatch(
          updateDPName({
            id: brokerId.toString(), // Always use the existing ID
            brokerName: currentName,
          })
        )) as unknown as DPNameType;

        history.push('/broker-name', {
          brokerId: Number(updatedBroker.id),
        });
      } else {
        const newBroker = (await dispatch(
          addDPName({
            brokerName: (values.brokerName ?? '').trim(),
          })
        )) as unknown as DPNameType;
        history.push('/broker-name', {
          brokerId: Number(newBroker.id),
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          overflowX: 'hidden',
          minHeight: '100vh',
          bgcolor: { xs: '', md: 'rgba(238, 244, 251, 0.5)' },
        }}>
        <Box
          component="main"
          sx={{
            mt: { xs: 2, md: 3 },
            p: { xs: 2, md: '50px' },
            pt: { xs: 2, md: '20px' },
            minHeight: 'calc(100vh - 108px)',
            width: '100%',
            boxSizing: 'border-box',
          }}>
          {/* <CommonLayout> */}
          <Formik
            initialValues={brokerInitialValues}
            enableReinitialize
            onSubmit={handleSubmit}
            validate={(values) => {
              try {
                // validateYupSchema(values, addBrokerValidation, true, values);
              } catch (e) {
                return yupToFormErrors(e);
              }
            }}>
            {({ handleSubmit }) => (
              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{
                  bgcolor: 'white',
                  boxShadow: '0px 4px 12px rgba(0,0,0,0.05)',
                  borderRadius: '10px',
                  py: { xs: 2, sm: 5 },
                  px: { xs: 2, sm: 5 },
                  mt: { xs: 2, sm: 5 },
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: { xs: 16, sm: 18 },
                    fontWeight: 500,
                    mb: { xs: 2, md: 4 },
                    p: { xs: '5px 15px', md: 0 },
                    bgcolor: '#e5f1f8',
                    borderRadius: '10px',
                  }}>
                  <Hidden only="xs">
                    <IconButton
                      onClick={() => history.push('/broker-name')}
                      sx={{
                        p: 0,
                        mr: 1,
                      }}>
                      <NavigateBeforeIcon />
                    </IconButton>
                  </Hidden>

                  <Typography
                    sx={{
                      fontSize: { xs: 18, sm: 20 },
                      fontWeight: 600,
                      color: '#1C2D47',
                    }}>
                    {brokerId ? 'Edit Broker Name' : 'Add Broker Name'}
                  </Typography>
                </Box>
                {/* <Typography
                  sx={{
                    color: 'common.blue',
                    fontWeight: 600,
                    fontSize: { xs: 14, sm: 16 },
                    ml: 3,
                  }}>
                  Broker Details
                </Typography> */}

                <Grid container>
                  <Grid item xs={12} sm={8}>
                    <MFTextField
                      name="brokerName"
                      label="Broker Name *"
                      placeholder="Enter Broker Name"
                    />
                  </Grid>
                </Grid>

                <Box
                  sx={{
                    width: '100%',
                    maxWidth: 350,
                    mx: 'auto',
                    mt: 5,
                  }}>
                  {/* <MFSubmitButton label={brokerId ? 'Update Broker' : 'Save'} /> */}
                  <MFSubmitButton label={'Save'} />
                </Box>
              </Box>
            )}
          </Formik>
        </Box>
      </Box>
      {/* </CommonLayout> */}
    </>
  );
}
